import { TActions, TActionsApiSubstitutes } from 'types/actions'
import { TAppTypesDisplaySubsitutes } from 'types/apps'

const actionsSubstitutes: Record<TActions, TActionsApiSubstitutes> = {
  VIEW: 'read',
  EDIT: 'update',
  'EDIT/DELETE': 'delete',
  CANCEL: 'delete',
  'EDIT/REFUND': 'delete',
}

const actionsFrontEndSubstitutes: Record<TActionsApiSubstitutes, TActions> = {
  read: 'VIEW',
  update: 'EDIT',
  delete: 'EDIT/DELETE',
}

export const convertActionToApiValue = (action: TActions) => {
  return actionsSubstitutes[action] ?? ''
}

export const convertActionToFrontEndValue = (
  action: TActionsApiSubstitutes,
  subject: TAppTypesDisplaySubsitutes
) => {
  // for availability and refund apps there are diffrent delete substitutes
  if (action === 'delete') {
    switch (subject) {
      case 'Status':
        return 'CANCEL'
      case 'Orders':
        return 'EDIT/REFUND'
      default:
        return 'EDIT/DELETE'
    }
  } else {
    return actionsFrontEndSubstitutes[action]
  }
}
